import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=2a97f888&scoped=true"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=2a97f888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97f888",
  null
  
)

export default component.exports